import { BODYTYPE_COLOR_LIST } from '../const';
import cookies from 'js-cookie';
import config from '../config';
import '../types/global.d.ts';

export const getImageUrl = (path: string) => {
    // 이미지 경로 변환 함수
    return new URL(path.replace('@/', '/src/'), import.meta.url).href;
};

/**
 * 애플 기기 여부 체크
 * @returns true|false
 */
export function isAppleDevice() {
    let userAgent = navigator.userAgent.toLocaleLowerCase();
    if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        return true;
    } else {
        return false;
    }
}

/**
 * 터치 디바이스 여부 체크
 * @returns true|false
 */
export function isTouchDevice() {
    return navigator.maxTouchPoints || 'ontouchstart' in document.documentElement;
}

/**
 * 모바일 여부 체크
 * @returns true|false
 */
export function isMobile() {
    return /Mobi/i.test(window.navigator.userAgent);
}

/**
 * 웹뷰 뷰 여부 체크
 * @param { String } routeName
 * @returns { Boolean }
 */
export function isWebviewView(routeName: string) {
    return routeName === 'in-app-cluster-info' ? false : true;
}

/**
 * 네이티브 전송 시 내부 코드는 camelCase로 전송
 */

/**
 * 웹 공용 뒤로가기 액션
 */
export function historyPage(isForceClose: boolean = false) {
    if (window.location.pathname === '/' || isForceClose) {
        console.log('EXIT');
        commonAppCall('EXIT', false);
    }
    //    else if (window.location.search.indexOf('direct=1') > -1) {
    //       console.log('EXIT');
    //       commonAppCall('EXIT');
    //    }
    else {
        console.log('history.back()');
        history.back();
    }
}

/**
 * 키보드 숨기기 공통 액션
 */
export function hideKeyboard() {
    commonAppCall('HIDE_KEYBOARD', false);
}

/**
 * 진동 호출
 */
export function callVibrate() {
    commonAppCall('VIBE', false);
}

/**
 * 웹뷰 로드 완료 호출
 */
export function callWebViewReady() {
    commonAppCall('WEBVIEW_READY', false);
}

/**
 * 프로 구독 페이지 이동 호출
 */
export function callNavigateToProSubscribe() {
    commonAppCall('navigateToProSubscribe', false);
}

/**
 * 프로 구독 페이지 이동 호출 V2 (Android 브릿지 키)
 */
export function callNavigateToProSubscribeV2() {
    commonAppCall('NAVIGATE_PROPLAN_SUBSCRIPTION', false);
}

/**
 * 현재 브라우져가 아닌 신규 브라우져 띄움
 * @param { String } outLinkUrl url 링크
 */
export function appOutLink(outLinkUrl: string) {
    //    if (cookies.get('fromMobileApp') === 'true') {
    if (!config.isLocalDevelopment) {
        let data = {
            ViewCode: 'OutLink',
            URL: outLinkUrl,
        };

        commonAppCall(data, true);
    } else {
        window.open(outLinkUrl, '_blank', 'noopener,noreferrer');
    }
}

/**
 * 앱 내 공유하기 호출
 * @param { String } outLinkUrl url 링크
 */
export function appShareLink(shareUrl: string) {
    //    if (cookies.get('fromMobileApp') === 'true') {
    if (!config.isLocalDevelopment) {
        let data = {
            ViewCode: 'Share',
            URL: shareUrl,
        };

        commonAppCall(data, true);
    } else {
        window.open(shareUrl, '_blank', 'noopener,noreferrer');
    }
}

/**
 * 웹뷰 헤더 숨김 상태 네이티브 호출
 * @param { Boolean } isHideHeader 헤더 숨김 여부
 */
export function sendHeaderHiddenStatusToNative(isHideHeader: boolean) {
    //    if (cookies.get('fromMobileApp') === 'true') {
    if (!config.isLocalDevelopment) {
        let data = {
            isHideHeader,
        };

        commonAppCall(data, true);
    } else {
        console.log('sendHeaderHiddenStatusToNative', isHideHeader);
    }
}

/**
 * 로드 후 높이값 전달
 * @param { Number } height 높이값
 */
export function sendContentHeightToNative(height: number) {
    //    if (cookies.get('fromMobileApp') === 'true') {
    if (!config.isLocalDevelopment) {
        let data = {
            webViewLayout: {
                height: height,
            },
        };

        commonAppCall(data, true);
    } else {
        return;
    }
}

// /**
//  * 랜딩 정보 생성 및 전송
//  * @param { Object } rendingInfo 랜딩 데이터
//  */
// export function appLanding(rendingInfo) {
//    let data = {
//       ViewCode: rendingInfo.viewCode,
//       RendingCode: rendingInfo.rendingCode,
//       RendingData: rendingInfo.rendingData,
//    };

//    console.log(JSON.stringify(data));
//    commonAppCall(data, true);
// }

/**
 * 앱으로 랜딩 정보 전송
 * @param { Object } data 랜딩 데이터
 * @param { boolean } isAllowStringify Stringify 필요 여부
 * @returns
 */

export function commonAppCall(data: object | string, isAllowStringify: boolean) {
    // if (config.isLocalDevelopment) return;

    let userAgent = navigator.userAgent.toLocaleLowerCase();
    let jsonStringfyData: string | object | null = null;

    if (isAllowStringify) {
        jsonStringfyData = JSON.stringify(data);
    } else {
        jsonStringfyData = data;
    }

    if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        return window.webkit?.messageHandlers.handleNativeApp.postMessage(jsonStringfyData);
    } else {
        return window.handleNativeApp?.callAndroid(jsonStringfyData);
    }
}

/**
 * 유효기간 1년으로 쿠키값 저장
 * @param { String } key
 * @param { * } value
 */
export function setCookieForYear(key: string, value: string) {
    // App 정보는 만료시간 360일 후 설정
    const expAppInfo = new Date();
    expAppInfo.setTime(expAppInfo.getTime() + 1000 * 60 * 60 * 24 * 30 * 12);
    cookies.set(key, value, { expires: expAppInfo });
}

/**
 * 유효기간 x일으로 쿠키값 저장
 * @param { String } key
 * @param { * } value
 */
export function setCookieForDays(key: string, value: string, day: number) {
    // App 정보는 만료시간 day일 후 설정
    const expAppInfo = new Date();
    expAppInfo.setTime(expAppInfo.getTime() + 1000 * 60 * 60 * 24 * day);
    cookies.set(key, value, { expires: expAppInfo });
}
/**
 * 유효기간 1일으로 쿠키값 저장
 * @param { String } key
 * @param { * } value
 */
export function setCookieForDay(key: string, value: string) {
    // App 정보는 만료시간 1일 후 설정
    const expAppInfo = new Date();
    expAppInfo.setTime(expAppInfo.getTime() + 1000 * 60 * 60 * 24);
    cookies.set(key, value, { expires: expAppInfo });
}

// export function dataURLtoFile(dataurl, fileName) {
//    var arr = '';
//    var mime = '';
//    var bstr = '';
//    var n = '';
//    var u8arr = '';

//    try {
//       arr = dataurl.split(',');
//       mime = arr[0].match(/:(.*?);/)[1];
//       bstr = atob(arr[1]);
//       n = bstr.length;
//       u8arr = new Uint8Array(n);
//       while (n--) {
//          u8arr[n] = bstr.charCodeAt(n);
//       }
//       if (u8arr.length === 0 || u8arr.length !== bstr.length) {
//          return null;
//       }
//    } catch (e) {
//       return null;
//    }
//    return new File([u8arr], fileName, { type: mime });
// }

/**
 * iOS 키보드 자동 완성 기능 숨기기
 */
export function disableAutoCompleteForIOS() {
    if (cookies.get('AppType') === 'IOS') {
        var textFields = document.getElementsByTagName('textarea');
        if (textFields) {
            var i;
            for (i = 0; i < textFields.length; i++) {
                var txtField = textFields[i];
                if (txtField) {
                    txtField.setAttribute('autocomplete', 'off');
                    txtField.setAttribute('autocorrect', 'off');
                    txtField.setAttribute('autocapitalize', 'off');
                    txtField.setAttribute('spellcheck', 'false');
                }
            }
        }
    }
}

// export function checkUsableFunctionWithOSVersion(iosRefAppVersion, aosRefAppVersion) {
//    let isAble = false;
//    try {
//       const fullappversion = cookies.get('AppVersion');
//       const apptype = cookies.get('AppType').toLowerCase();
//       let appversion = fullappversion;
//       if (apptype !== 'ios') {
//          if (fullappversion.indexOf('(') > -1) {
//             appversion = fullappversion.split('(')[0];
//          } else if (fullappversion.indexOf('_') > -1) {
//             appversion = fullappversion.split('_')[0];
//          }
//       }

//       let refAppVersion = apptype !== 'ios' ? aosRefAppVersion : iosRefAppVersion;
//       let arrAppVersion = appversion.split('.');
//       for (let i = 0; i < arrAppVersion.length; i++) {
//          let value = arrAppVersion[i];
//          if (Number(value) > refAppVersion[i]) {
//             isAble = true;
//             break;
//          } else if (Number(value) === refAppVersion[i]) {
//             if (i === arrAppVersion.length - 1) isAble = true;
//             else continue;
//          } else {
//             isAble = false;
//             break;
//          }
//       }
//    } catch (e) {
//       console.log('e : ' + e);
//    }

//    return isAble;
// }

// export function compareNumNKor(a, b) {
//    // Check if both elements are numbers
//    if (typeof a.sortCharacter === 'number' && typeof b.sortCharacter === 'number') {
//       return a.sortCharacter - b.sortCharacter;
//    }

//    // Check if both elements are strings
//    if (typeof a.sortCharacter === 'string' && typeof b.sortCharacter === 'string') {
//       // Compare the strings using localeCompare for Korean characters
//       return a.sortCharacter.localeCompare(b.sortCharacter, 'ko');
//    }

//    // Sort numbers before strings
//    if (typeof a.sortCharacter === 'number') {
//       return -1;
//    }

//    // Sort strings after numbers
//    return 1;
// }

// export function sortArrayAscendWithNumNKor(array) {
//    return array.sort(compareNumNKor);
// }

// export function compareNumNKor2(a, b) {
//    // Check if both elements are numbers
//    if (typeof a === 'number' && typeof b === 'number') {
//       return a - b;
//    }

//    // Check if both elements are strings
//    if (typeof a === 'string' && typeof b === 'string') {
//       // Compare the strings using localeCompare for Korean characters
//       return a.localeCompare(b, 'ko');
//    }

//    // Sort numbers before strings
//    if (typeof a === 'number') {
//       return -1;
//    }

//    // Sort strings after numbers
//    return 1;
// }

// export function sortArrayAscendWithNumNKor2(array) {
//    return array.sort(compareNumNKor2);
// }

/**
 *
 * @param clusterTypeEnglishName (ex. lightobesity of lightobesity1)
 * @param clusterGroup (ex. 2040)
 * @param isClassName true 클래스 이름 / false 색상값
 * @returns
 */
export function getBodyTypeColor(clusterTypeEnglishName: string, clusterGroup?: string, isClassName: boolean = false) {
    // ex) Muscle1
    let targetCode = clusterTypeEnglishName.replace(/[^a-zA-Z]/g, '').toLowerCase();
    targetCode = targetCode.charAt(0).toUpperCase() + targetCode.slice(1);

    if (targetCode === 'Slender') {
        targetCode = `${targetCode}_${clusterGroup}`;
    }

    return (
        BODYTYPE_COLOR_LIST.find((item: BodyTypeColorItem) => targetCode === item.bodyTypeCode)?.[
            isClassName ? 'className' : 'color'
        ] || ''
    );
}

/**
 * @param clusterTypeEnglishName
 * @param clusterGroup
 * @param key
 * @returns
 */
interface BodyTypeColorItem {
    bodyTypeCode: string;
    bodyTypeKoreanName: string;
    color: string;
    className: string;
}

export function getBodyTypeValue<K extends keyof BodyTypeColorItem>(
    clusterTypeEnglishName: string,
    key: K,
    clusterGroup?: string,
): BodyTypeColorItem[K] | '' {
    // ex) Muscle1 -> Muscle
    let targetCode = clusterTypeEnglishName.replace(/[^a-zA-Z]/g, '').toLowerCase();
    targetCode = targetCode.charAt(0).toUpperCase() + targetCode.slice(1);

    if (targetCode === 'Slender') {
        targetCode = `${targetCode}_${clusterGroup}`;
    }

    return BODYTYPE_COLOR_LIST.find((item: BodyTypeColorItem) => item.bodyTypeCode === targetCode)?.[key] ?? '';
}

export function setLocalStorage(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorage(key: string) {
    return localStorage.getItem(key);
}

export function removeLocalStorage(key: string) {
    localStorage.removeItem(key);
}

export function capitalizeFirstLetterOfEachWord(str: string) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
}

/**
 * i18n 텍스트 치환
 * @param template 텍스트
 * @param data 데이터
 * @returns 치환된 텍스트
 */
export function replaceTextTemplate(text: string, data: Record<string, string | number | undefined>): string {
    return text.replace(/#(.*?)#/g, (_, key) => {
        const value = data[key];
        return value !== undefined ? String(value) : '';
    });
}
